import { render, staticRenderFns } from "./Tools.vue?vue&type=template&id=0c4d53f8&scoped=true"
import script from "./Tools.vue?vue&type=script&lang=js"
export * from "./Tools.vue?vue&type=script&lang=js"
import style0 from "./Tools.vue?vue&type=style&index=0&id=0c4d53f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4d53f8",
  null
  
)

export default component.exports